import { create } from "zustand";
import type { CvImportPreview } from "@/components/save/cv-extraction-to-preview";

// Carries a CV extraction's genesis ProfileImportPreview from the CV Extractor
// dialog to the profile page across the navigation between them. genesis already
// produced the two-sided diff (same contract as the LinkedIn importer), so the
// dialog just stashes that preview here and navigates; ProfilePage adapts it to
// PreviewData and opens the in-line merge review, then clears this. In-memory
// only (a refresh drops it and the user re-extracts — same rationale as the
// merge preview store).

interface CvImportState {
  pending: { fragment: CvImportPreview; fileName: string } | null;
  /** Stash a freshly extracted preview for the profile page to pick up. */
  start: (fragment: CvImportPreview, fileName: string) => void;
  /** Clear once the profile page has handed it to the merge store. */
  clear: () => void;
}

export const useCvImportStore = create<CvImportState>((set) => ({
  pending: null,
  start: (fragment, fileName) => set({ pending: { fragment, fileName } }),
  clear: () => set({ pending: null }),
}));
